/* eslint-disable no-nested-ternary */
import React, { useEffect } from 'react';

import { LayoutComponent_LocalLoader as LayoutComponentLocalLoader } from 'ggApp/modules/layout';
import { TranslatorComponent_Text as Translator } from 'ggApp/modules/translator';
import { carouselValidation } from 'ggApp/shared/components/widgets/CampaignCarousel/utils';
import useUspCardsContent from 'ggApp/shared/hooks/useUspCardsContent';
import {
    getContentfulWidgetContent,
    extractProductWidgetData,
} from 'ggApp/shared/components/widgets/utils/widgetAdapter';

import { getHIWPageUrl } from 'ggApp/utils/path';
import {
    Campaign,
    FallbackMC1,
    CampaignCarouselWidget,
    Line,
    WidgetGrid,
    TileMarketingWidget,
    UspCardsWidget,
    ReviewsWidget,
    ProductWidget,
} from './styled';
import ValuePropsSection from './ValuePropsSection/ValuePropsSection';
import RecentlyViewSection from '../BaseLayout/RecentlyViewSection';
import CategoriesWidget from '../widgets/CategoriesWidget';

export const ForYou = ({
    widgetList,
    className,
    productImpressionCallbacks,
    children,
    categoryList,
    homePageContent,
    widgetListProducts,
    activeStore: { activeLanguage, code },
    initDone,
    isUserLoggedIn,
    getFavoritesProducts,
    favoriteList,
    categoriesWidgetOnHomepageEnabled,
    location,
}) => {
    useEffect(() => {
        if (initDone && isUserLoggedIn) {
            getFavoritesProducts(undefined, false);
        }
    }, [initDone, getFavoritesProducts, isUserLoggedIn]);

    const carouselContent = (homePageContent && homePageContent.campaignBannerCarousel) || null;
    const withCarousel = carouselValidation(carouselContent) && !window.ReactNativeWebView;
    const bannerContent = (homePageContent && homePageContent.campaignBanner) || null;
    const mc2 = getContentfulWidgetContent({ homePageContent, position: 'marketingCard2' });
    const mc3 = getContentfulWidgetContent({ homePageContent, position: 'marketingCard3' });
    const uspCardsContent = useUspCardsContent(activeLanguage);
    const productWidgets = extractProductWidgetData(widgetList);
    const {
        countdown,
        topProducts,
        newProducts,
        category1,
        category2,
        mostPopular,
        handpicked1,
        handpicked2,
        handpicked3,
        deals,
    } = productWidgets;

    const sortedWidgetListProducts = [];
    if (widgetListProducts && Array.isArray(widgetListProducts)) {
        widgetListProducts.forEach((element, index) => {
            const product = element;
            product.position = index;
            sortedWidgetListProducts.push(product);
        });
    }

    const productWidgetProps = {
        favoriteList,
        productImpressionCallbacks,
        widgetListProducts: sortedWidgetListProducts,
    };

    const campaignCarouselOptions = { autoplay: true };

    return (
        <div className={className}>
            {children}
            {withCarousel ? (
                <CampaignCarouselWidget cards={carouselContent} options={campaignCarouselOptions} />
            ) : bannerContent ? (
                <Campaign campaignBannerContent={bannerContent} />
            ) : (
                <FallbackMC1 />
            )}
            <ValuePropsSection />
            {categoriesWidgetOnHomepageEnabled ? (
                <CategoriesWidget categoryList={categoryList?.data} />
            ) : null}
            <Line title={<Translator tk="DIVISION_LINE_FOR_YOU_FEED" />} />
            <LayoutComponentLocalLoader fullHeight active={!productWidgets}>
                <WidgetGrid>
                    {countdown && countdown.products && (
                        <ProductWidget
                            widgetData={countdown}
                            testId="countdownWidget"
                            {...productWidgetProps}
                        />
                    )}
                    {topProducts && topProducts.products && (
                        <ProductWidget
                            widgetData={topProducts}
                            testId="topProductsWidget"
                            {...productWidgetProps}
                        />
                    )}
                </WidgetGrid>
                <RecentlyViewSection location={location} placement="top" />
                <WidgetGrid>
                    {mc2 ? (
                        <TileMarketingWidget
                            headerText={mc2.title}
                            bodyText={mc2.description}
                            backgroundImage={mc2.image.url}
                            ctaLink={mc2.ctaLink}
                            ctaText={mc2.ctaText}
                        />
                    ) : (
                        <TileMarketingWidget fallback="mc2" />
                    )}
                    {newProducts && newProducts.products && (
                        <ProductWidget
                            widgetData={newProducts}
                            testId="newProductsWidget"
                            {...productWidgetProps}
                            ctaViewAll
                        />
                    )}
                    {category1 && category1.products && (
                        <ProductWidget
                            widgetData={category1}
                            testId="categoryWidget"
                            {...productWidgetProps}
                            ctaViewAll
                        />
                    )}
                    {category2 && category2.products && (
                        <ProductWidget widgetData={category2} {...productWidgetProps} />
                    )}
                    {uspCardsContent && (
                        <UspCardsWidget
                            title={uspCardsContent.title}
                            steps={uspCardsContent.steps}
                            cta={{
                                label: 'TIPS_LINKS_HIW_TEXT',
                                url: getHIWPageUrl(code, activeLanguage),
                                external: true,
                            }}
                        />
                    )}
                    <ReviewsWidget />
                    {mostPopular && mostPopular.products && (
                        <ProductWidget
                            widgetData={mostPopular}
                            testId="mostPopularProductsWidget"
                            {...productWidgetProps}
                        />
                    )}
                    {handpicked1 && handpicked1.products && (
                        <ProductWidget
                            widgetData={handpicked1}
                            testId="handpickedProductWidget"
                            {...productWidgetProps}
                        />
                    )}
                    {mc3 ? (
                        <TileMarketingWidget
                            headerText={mc3.title}
                            bodyText={mc3.description}
                            backgroundImage={mc3.image.url}
                            ctaLink={mc3.ctaLink}
                            ctaText={mc3.ctaText}
                        />
                    ) : (
                        <TileMarketingWidget fallback="mc3" />
                    )}
                    {handpicked2 && handpicked2.products && (
                        <ProductWidget widgetData={handpicked2} {...productWidgetProps} />
                    )}
                    {handpicked3 && handpicked3.products && (
                        <ProductWidget widgetData={handpicked3} {...productWidgetProps} />
                    )}
                    {deals && deals.products && (
                        <ProductWidget
                            widgetData={deals}
                            testId="dealsProductsWidget"
                            {...productWidgetProps}
                        />
                    )}
                </WidgetGrid>
            </LayoutComponentLocalLoader>
        </div>
    );
};

export default ForYou;
